"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keywords = void 0;
// Reserved keywords not allowed to use in the parser
var keywords = exports.keywords = new Set(['end']);